import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { usePageMessages } from 'apps/auth/hooks/selectors';

interface ReportProblemModalProps {
    modalRef: React.RefObject<{ close: () => void }>;
}

const ReportProblemModalComponent: React.FC<ReportProblemModalProps> = (props) => {
    const { gotIt, reportProblemTitle, reportProblemSubtitle } =
        usePageMessages<{
            gotIt?: string;
            reportProblemTitle?: string;
            reportProblemSubtitle?: string;
        }>() ?? {};

    return (
        <ModalComponent isVerticalCentered canCloseModal={false}>
            <InfoPage
                insideModalComponent
                iconName="check-circle-80"
                iconColor="primary"
                headerText={<DangerouslyHtml dangerouslyHtml={reportProblemTitle} />}
                secondaryText={<DangerouslyHtml dangerouslyHtml={reportProblemSubtitle} />}
                primaryButtonCaption={gotIt}
                primaryButtonType="button"
                primaryButtonOnClick={() => {
                    props.modalRef.current?.close();
                }}
            />
        </ModalComponent>
    );
};

export default connect(null, { toggleSpinner })(ReportProblemModalComponent);
